import {
	CreateSkillData,
	FilterSkillQuery,
	GetAllSkillsAPIResponse,
	GetOnlySkillsAPIResponse,
	GetSkillByIdAPIResponse,
	UpdateSkillByIdInput,
} from 'types';
import { baseApi } from './axios';
import { BaseAPIResponse } from 'types';

const baseUrl = `${process.env.REACT_APP_API_URL}/skill`;
export const createSkill = async (payload: CreateSkillData): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/create`, payload);
	return response.data;
};

export const getOnlySkills = async (): Promise<GetOnlySkillsAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/get-only-skills`);
	return response.data;
};

export const getAllSkills = async (payload?: FilterSkillQuery['filterQuery']): Promise<GetAllSkillsAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/all`, {
		params: payload, // Use "params" to send data as query parameters
	});
	return response.data;
};

export const getAllPublicSkills = async (
	payload?: FilterSkillQuery['filterQuery'],
): Promise<GetAllSkillsAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/getAllPublicSkills`, {
		params: payload, // Use "params" to send data as query parameters
	});
	return response.data;
};

export const getAllSellableSkills = async (): Promise<GetAllSkillsAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/sellable-skills`);
	return response.data;
};

export const getAllSellableSkillsForMentor = async (): Promise<GetAllSkillsAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/sellable-skills`);
	return response.data;
};

export const getResumeSkills = async (): Promise<GetAllSkillsAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/resume-skills`);
	return response.data;
};

export const getSkillById = async (id: string): Promise<GetSkillByIdAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/${id}`);
	return response.data;
};

export const updateSkillById = async (payload: UpdateSkillByIdInput): Promise<BaseAPIResponse> => {
	const { id, updateInfo } = payload;
	const response = await baseApi.patch(`${baseUrl}/${id}`, { ...updateInfo });
	return response.data;
};
